"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[43983],{

/***/ 243983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductCombo": function() { return /* binding */ ProductCombo; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 5 modules
var ProductDetailContext = __webpack_require__(316035);
// EXTERNAL MODULE: ./hooks/useComboList.tsx
var useComboList = __webpack_require__(453594);
// EXTERNAL MODULE: ./components/desktop/organisms/Combo/ComboItem.tsx
var ComboItem = __webpack_require__(905006);
// EXTERNAL MODULE: ./components/desktop/organisms/Combo/DetailComboModal.tsx + 1 modules
var DetailComboModal = __webpack_require__(375329);
// EXTERNAL MODULE: ./hooks/useCartCombo.tsx
var useCartCombo = __webpack_require__(627735);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Glide/Glide.es.js + 1 modules
var Glide_es = __webpack_require__(349416);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ./components/desktop/organisms/Combo/ComboCarousel.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









const ComboCarousel = (param)=>{
    let { comboList , mainSku  } = param;
    const { 0: visibleDetail , 1: setVisibleDetail  } = (0,react.useState)(false);
    const { 0: activeCombo , 1: setActiveCombo  } = (0,react.useState)();
    const { onAddComboToCart  } = (0,useCartCombo/* useCartCombo */.z)(mainSku);
    const { title , onSlideChange  } = (0,useComboList/* useComboTitle */.eV)(comboList);
    const handleAddToCart = (comboItem)=>{
        const payload = {
            promotionId: comboItem.promotionId,
            comboLineItems: comboItem.items.map((el)=>{
                const convertedProduct = (0,discovery/* convertProductDetail */.NP)(el.product);
                return {
                    sku: convertedProduct.sku,
                    quantity: el.quantity,
                    selectPromotionId: convertedProduct.selectPromotionId
                };
            })
        };
        onAddComboToCart === null || onAddComboToCart === void 0 ? void 0 : onAddComboToCart(comboItem.type, payload, false);
    };
    const handleViewDetailCombo = (comboItem)=>{
        const comboLineItems = comboItem.items.map((el)=>{
            const convertedProduct = (0,discovery/* convertProductDetail */.NP)(el.product);
            return {
                sku: convertedProduct.sku,
                quantity: el.quantity,
                selectPromotionId: convertedProduct.selectPromotionId
            };
        });
        setActiveCombo({
            type: comboItem.type,
            comboLineItems,
            promotionId: comboItem.promotionId
        });
        setVisibleDetail(true);
    };
    if (comboList.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
        marginBottom: "s24",
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
            title: title || "",
            link: comboList.length > 1 ? {
                color: "primary500",
                href: "/products/".concat(mainSku, "/combos")
            } : undefined,
            tracking: (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "productComboCarousel",
                contentName: "viewAllCombo",
                target: "comboList"
            })
        }),
        children: [
            comboList.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboItem/* ComboItem */.e, _objectSpread({
                comboItem: comboList[0],
                onAddToCart: ()=>handleAddToCart(comboList[0]),
                onViewDetail: ()=>handleViewDetailCombo(comboList[0])
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "productComboList",
                contentName: "productComboItem",
                index: 1
            }))) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Glide_es/* Glide */.A, {
                perView: 1,
                onSlideChange: onSlideChange,
                children: comboList.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ComboItem/* ComboItem */.e, _objectSpread({
                        comboItem: el,
                        onAddToCart: ()=>handleAddToCart(el),
                        onViewDetail: ()=>handleViewDetailCombo(el)
                    }, (0,helper_es/* getTrackingData */.O5)({
                        isTrackContent: true,
                        regionName: "productComboList",
                        contentName: "productComboItem",
                        index
                    })), index))
            }),
            activeCombo && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailComboModal/* DetailComboModal */.b, _objectSpread({
                visible: visibleDetail,
                onCloseModal: ()=>{
                    setVisibleDetail(false);
                    setActiveCombo(undefined);
                },
                onAddToCart: async (type, payload)=>{
                    await (onAddComboToCart === null || onAddComboToCart === void 0 ? void 0 : onAddComboToCart(type, payload, false));
                    setVisibleDetail(false);
                    setActiveCombo(undefined);
                }
            }, activeCombo))
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tabs/Tabs.es.js
var Tabs_es = __webpack_require__(517844);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tabs/TabItem.es.js
var TabItem_es = __webpack_require__(640793);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(991822);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(54230);
;// CONCATENATED MODULE: ./assets/combo-header-label.svg
/* harmony default export */ var combo_header_label = ("https://shopfront-cdn.tekoapis.com/_next/static/images/combo-header-label-3f8f9c04b799790b1ff69cf49047ffd3.svg");
;// CONCATENATED MODULE: ./assets/icon-combo-desktop.png
/* harmony default export */ var icon_combo_desktop = ("https://shopfront-cdn.tekoapis.com/_next/static/images/icon-combo-desktop-1509772e4d9f756f3295b93d7acc2887.png");
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/Tooltip.es.js
var Tooltip_es = __webpack_require__(386877);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CashColored.es.js
var CashColored_es = __webpack_require__(290184);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/VoucherColored.es.js
var VoucherColored_es = __webpack_require__(526397);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/GiftColored.es.js
var GiftColored_es = __webpack_require__(971219);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CautionOutlined.es.js
var CautionOutlined_es = __webpack_require__(47649);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../packages/types/dist/shared/index.js
var shared = __webpack_require__(414951);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./helpers/combo.ts
var helpers_combo = __webpack_require__(662295);
// EXTERNAL MODULE: ./components/desktop/organisms/Combo/ComboProductPrice.tsx
var ComboProductPrice = __webpack_require__(875761);
// EXTERNAL MODULE: ./components/desktop/organisms/Combo/PromotionBenefitInfo.tsx
var PromotionBenefitInfo = __webpack_require__(987540);
;// CONCATENATED MODULE: ./components/desktop/organisms/Combo/ComboItemNew.tsx
function ComboItemNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ComboItemNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ComboItemNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  &.not-last-item {\n    &:after {\n      content: '+';\n      position: absolute;\n      right: -4px;\n      top: 60px;\n      color: #a7abc3;\n      font-size: 18px;\n      cursor: auto;\n    }\n  }\n  &.not-last-item.full-col-width {\n    &:after {\n      content: '+';\n      position: absolute;\n      right: -24px;\n      top: 60px;\n      color: #a7abc3;\n      font-size: 18px;\n      cursor: auto;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    border-right: 1px solid #e4e5f0;\n    height: 125px;\n  }\n  &.full-col-width {\n    &:before {\n      content: ' ';\n      position: absolute;\n      left: -20px;\n      color: #a7abc3;\n      border-right: 1px solid #a7abc3;\n      height: 125px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 125px;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 16px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  color: white;\n  padding: 2px 5px;\n  top: 8px;\n  left: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  min-height: 32px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 125px;\n  height: 125px;\n  background-color: rgba(27, 29, 41, 0.5);\n  color: #ffffff;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 125px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  text-transform: uppercase;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  box-shadow: 1px 1px 3px 0px #e6e6e6;\n  width: 420px;\n  padding: 16px 20px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}












const MAX_COL_NUMBER = 5;
const ComboItemNew = (param)=>{
    let { index , combo , onClickProductChange ,  } = param;
    var ref, ref1;
    const { totalProduct , promotion , conditions , totalAmount , totalDiscount  } = combo;
    const { onAddComboItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    const { numberDisplayFormat , epicOmni1643  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const numberOfColumns = conditions.length + (promotion.benefit ? 1 : 0) > MAX_COL_NUMBER ? MAX_COL_NUMBER : conditions.length + (promotion.benefit ? 1 : 0);
    const span = 12 / numberOfColumns;
    const productColumnNumber = numberOfColumns - (promotion.benefit ? 1 : 0);
    const isNotEnoughProductColumn = conditions.length > productColumnNumber;
    const residualProductQuantity = (0,react.useMemo)(()=>{
        if (isNotEnoughProductColumn) {
            let result = 0;
            for(let index = 0; index < productColumnNumber - 1; index++){
                result += conditions[index].requiredQuantity;
            }
            return totalProduct - result;
        }
        return 0;
    }, [
        JSON.stringify(conditions),
        isNotEnoughProductColumn
    ]);
    const addComboToCart = async ()=>{
        const mainPayload = {
            override: true,
            groups: [
                {
                    quantity: 1,
                    promotionId: promotion.id,
                    products: conditions.map((el, index)=>{
                        var ref, ref1;
                        return {
                            sku: el.product.sku,
                            promotionId: !!((ref = el.product.bestPromotionIds) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = el.product.bestPromotionIds) === null || ref1 === void 0 ? void 0 : ref1[0] : null,
                            quantity: el.requiredQuantity,
                            isPrimary: index === 0
                        };
                    })
                }, 
            ]
        };
        await onAddComboItems(mainPayload, false);
    };
    const BenefitItem = (param)=>{
        let { benefit  } = param;
        const { numberOfBenefit  } = (0,helpers_combo/* countAndGetBenefitDescription */.sE)(benefit);
        const { discount , voucher , gifts  } = benefit;
        const discountValue = (discount === null || discount === void 0 ? void 0 : discount.flat) || (discount === null || discount === void 0 ? void 0 : discount.percent) || 0;
        const BenefitTag = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTag, {
                type: "ghost",
                variant: "branding",
                content: numberOfBenefit === 1 && discountValue > 0 ? (0,i18n.t)("Giảm ngay") : (0,i18n.t)("Tặng ngay")
            });
        const GiftTooltipContent = (param)=>{
            let { gifts , promotionBenefit  } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                    level: 2,
                    color: "textSecondary",
                    children: (0,i18n.t)("Bạn nhận được").toLocaleUpperCase()
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionBenefitInfo/* PromotionBenefitInfo */.j, {
                    gifts: gifts,
                    promotionBenefit: promotionBenefit
                })
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionWrapper, {
            children: numberOfBenefit <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    discountValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBgPromotion, {
                                bgColor: "#E7FBED",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CashColored_es/* CashColored */.B, {
                                    size: 60
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapperTag, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTag, {}),
                                    (discount === null || discount === void 0 ? void 0 : discount.flat) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice_es/* ProductPrice */.j, {
                                        latestPrice: discountValue,
                                        numberDisplayFormat: numberDisplayFormat
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                                level: 1,
                                                color: "primary500",
                                                children: "".concat(discountValue, "%")
                                            }),
                                            (discount === null || discount === void 0 ? void 0 : discount.maxAmount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: [
                                                    (0,i18n.t)("Giảm tối đa"),
                                                    (0,number_es/* formatCurrency */.xG)(discount.maxAmount, numberDisplayFormat), 
                                                ].map((item)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                                        level: 1,
                                                        line: 2,
                                                        color: "primary500",
                                                        style: {
                                                            marginTop: "-4px"
                                                        },
                                                        children: "".concat(item)
                                                    }, "".concat(item));
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (voucher === null || voucher === void 0 ? void 0 : voucher.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBgPromotion, {
                                bgColor: "#FFF2F0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherColored_es/* VoucherColored */.C, {
                                    size: 60
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapperTag, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTag, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductName, {
                                        level: 1,
                                        line: 2,
                                        children: [
                                            voucher.quantity > 1 ? "".concat(voucher.quantity, " x ") : "",
                                            voucher === null || voucher === void 0 ? void 0 : voucher.name
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !!(gifts === null || gifts === void 0 ? void 0 : gifts.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooltip, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftTooltipContent, {
                            gifts: gifts.slice(1)
                        }),
                        backgroundColor: "white",
                        // Not show tooltip when has only a gift
                        show: gifts.slice(1).length > 0,
                        triggerHover: gifts.slice(1).length > 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    src: gifts[0].imageUrl || "",
                                    width: 125,
                                    height: 125,
                                    contain: true,
                                    borderRadius: 1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapperTag, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTag, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                            level: 1,
                                            line: 2,
                                            color: "#82869E",
                                            children: gifts[0].name || gifts[0].sku
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooltip, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftTooltipContent, {
                    promotionBenefit: benefit
                }),
                backgroundColor: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBgPromotion, {
                            bgColor: "#FFF2F0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftColored_es/* GiftColored */.x, {
                                size: 60
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapperTag, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTag, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                    level: 1,
                                    line: 2,
                                    color: "#434657",
                                    children: (0,i18n.t)("{{numberOfBenefit}} phần qu\xe0", {
                                        numberOfBenefit
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    };
    const ProductTooltipContent = (param)=>{
        let { residualProducts  } = param;
        const span = 12 / residualProducts.length;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                gutter: 16,
                children: residualProducts.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        span: span,
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                            href: "/products/".concat(item.product.sku),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionItem, {
                                    conditionKey: item.key,
                                    product: item.product,
                                    requiredQuantity: item.requiredQuantity,
                                    isCompactItem: false,
                                    tracking: item.tracking
                                })
                            })
                        })
                    }, index))
            })
        });
    };
    const ConditionItem = (item)=>{
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLazyImage, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            borderRadius: 4,
                            src: item.product.imageUrl,
                            hover: "zoom",
                            contain: true,
                            aspectRatio: 1,
                            alt: item.product.name
                        }),
                        item.isCompactItem && !!((ref = item.residualProducts) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooltip, {
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTooltipContent, {
                                residualProducts: item.residualProducts
                            }),
                            backgroundColor: "white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRemainBg, {
                                children: [
                                    "+",
                                    residualProductQuantity
                                ]
                            })
                        }),
                        item.requiredQuantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityTag, {
                            backgroundColor: "primary500",
                            children: [
                                item.requiredQuantity,
                                "x"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                    level: 1,
                    line: 2,
                    color: item.isCompactItem ? "#82869E" : "textPrimary",
                    style: item.isCompactItem ? {
                        textAlign: "center"
                    } : undefined,
                    children: item.isCompactItem ? (0,i18n.t)("v\xe0 {{var0}} sản phẩm kh\xe1c", {
                        var0: residualProductQuantity
                    }) : item.product.name
                }),
                item.isCompactItem ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboProductPrice/* ComboProductPrice */.$, {
                    price: item.product.price,
                    promotion: promotion,
                    textColor: "textPrimary"
                }),
                item.conditionKey > 1 && !item.isCompactItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, _objectSpreadProps(ComboItemNew_objectSpread({
                    marginTop: "s8",
                    align: "center",
                    onClick: (event)=>{
                        event.preventDefault();
                        onClickProductChange(item.product.sku, item.conditionKey);
                    }
                }, item.tracking), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                            color: "link500",
                            level: 1,
                            children: (0,i18n.t)("Thay đổi sản phẩm")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                            color: "link500",
                            size: 16
                        })
                    ]
                })) : null
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
        footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    justify: "space-between",
                    align: "bottom",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            children: [
                                !!totalDiscount && !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    justify: "start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            paddingRight: "s28",
                                            color: "textSecondary",
                                            level: 1,
                                            children: "".concat((0,i18n.t)("Tiết kiệm"), ":")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            color: "textSecondary",
                                            level: 1,
                                            children: (0,number_es/* formatCurrency */.xG)(totalDiscount, numberDisplayFormat)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    justify: "start",
                                    marginTop: "s8",
                                    align: "bottom",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            marginRight: "s16",
                                            level: 1,
                                            color: "textTitle",
                                            children: "".concat((0,i18n.t)("Tổng tiền"), ":")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                            color: "primary500",
                                            level: 1,
                                            children: (0,number_es/* formatCurrency */.xG)(totalAmount, numberDisplayFormat)
                                        })
                                    ]
                                }),
                                !!totalDiscount && epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    justify: "start",
                                    align: "bottom",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            marginRight: "s16",
                                            color: "#389E0D",
                                            level: 1,
                                            children: "".concat((0,i18n.t)("Tiết kiệm"), ":")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            color: "#389E0D",
                                            level: 1,
                                            children: (0,number_es/* formatCurrency */.xG)(totalDiscount, numberDisplayFormat)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, _objectSpreadProps(ComboItemNew_objectSpread({
                            variant: "secondary",
                            onClick: addComboToCart
                        }, (0,helper_es/* getTrackingData */.O5)({
                            isTrackContent: true,
                            regionName: "productComboList",
                            contentName: "btnAddToCart",
                            payload: JSON.stringify({
                                promotionType: "combo",
                                comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                comboPromotion: promotion.id,
                                comboIndex: index + 1,
                                skus: conditions.map((con)=>con.product.sku)
                            })
                        })), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                level: 2,
                                children: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                            })
                        }))
                    ]
                }),
                !!((ref = promotion.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.exclusions) === null || ref1 === void 0 ? void 0 : ref1.find((exclusion)=>{
                    var ref;
                    return (ref = exclusion.paymentMethods) === null || ref === void 0 ? void 0 : ref.includes("VNPAY_INSTALLMENT_CREDIT");
                })) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
                    height: 28,
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start"
                    },
                    backgroundColor: "pending50",
                    border: "1px solid pending100",
                    marginTop: "s12",
                    paddingLeft: "s12",
                    borderRadius: "s",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CautionOutlined_es/* CautionOutlined */.s, {
                            color: "pending600",
                            size: 16
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 1,
                            color: "pending600",
                            marginLeft: "s8",
                            children: (0,i18n.t)("Kh\xf4ng \xe1p dụng c\xf9ng chương tr\xecnh trả g\xf3p")
                        })
                    ]
                })
            ]
        }),
        padding: [
            "s16",
            "s40"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                style: {
                    justifyContent: "space-evenly"
                },
                children: [
                    conditions.map((param, index)=>{
                        let { product , requiredQuantity , key  } = param;
                        const isCompactItem = isNotEnoughProductColumn && index === productColumnNumber - 1;
                        if (isNotEnoughProductColumn && index >= productColumnNumber) return null;
                        const isLastItem = isNotEnoughProductColumn ? index === productColumnNumber - 1 : index === conditions.length - 1;
                        const residualProducts = isNotEnoughProductColumn ? conditions.slice(productColumnNumber - 1).map((residualProduct)=>_objectSpreadProps(ComboItemNew_objectSpread({}, residualProduct), {
                                tracking: (0,helper_es/* getTrackingData */.O5)({
                                    isTrackContent: true,
                                    regionName: "productComboList",
                                    contentName: "btnChangeProductCombo",
                                    payload: JSON.stringify({
                                        comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                        promotionType: "combo",
                                        skuIndex: index + 1,
                                        sku: product.sku
                                    })
                                })
                            })) : [];
                        const conditionItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionItem, {
                            conditionKey: key,
                            product: product,
                            requiredQuantity: requiredQuantity,
                            isCompactItem: isCompactItem,
                            residualProducts: residualProducts,
                            tracking: (0,helper_es/* getTrackingData */.O5)({
                                isTrackContent: true,
                                regionName: "productComboList",
                                contentName: "btnChangeProductCombo",
                                payload: JSON.stringify({
                                    comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                    promotionType: "combo",
                                    skuIndex: index + 1,
                                    sku: product.sku
                                })
                            })
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductCol, {
                                span: span,
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                className: "".concat(!isLastItem ? "not-last-item" : "", " ").concat(numberOfColumns === MAX_COL_NUMBER ? "full-col-width" : ""),
                                children: !!isCompactItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemWrapper, {
                                    children: conditionItem
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                    href: "/products/".concat(product.sku),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemWrapper, {
                                        children: conditionItem
                                    })
                                })
                            })
                        }, index);
                    }),
                    promotion.benefit && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPromotionCol, {
                        span: span,
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        className: numberOfColumns === MAX_COL_NUMBER ? "full-col-width" : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitItem, {
                            benefit: promotion.benefit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                dividerStyle: shared/* DividerStyleEnum.dashed */.fd.dashed,
                color: "divider"
            })
        ]
    });
};
const StyledProductCol = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)(_templateObject());
const StyledPromotionCol = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)(_templateObject1());
const ItemWrapper = emotion_styled_browser_esm["default"].div(_templateObject2());
const StyledLazyImage = emotion_styled_browser_esm["default"].div(_templateObject3());
const QuantityTag = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)(_templateObject4());
const StyledProductName = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)(_templateObject5());
const StyledRemainBg = emotion_styled_browser_esm["default"].div(_templateObject6());
const PromotionWrapper = emotion_styled_browser_esm["default"].div(_templateObject7());
const StyledWrapperTag = emotion_styled_browser_esm["default"].div(_templateObject8());
const StyledTag = (0,emotion_styled_browser_esm["default"])(Tag_es/* Tag */.V)(_templateObject9());
const StyledBgPromotion = emotion_styled_browser_esm["default"].div((param)=>{
    let { bgColor , size ="125px"  } = param;
    return "\n  width: ".concat(size, ";\n  height: ").concat(size, ";\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ").concat(bgColor, ";\n  border-radius: 4px;\n");
});
const StyledTooltip = (0,emotion_styled_browser_esm["default"])(Tooltip_es/* Tooltip */.u)(_templateObject10());

// EXTERNAL MODULE: ./components/desktop/organisms/Combo/ProductSelectionModal.tsx
var ProductSelectionModal = __webpack_require__(50343);
;// CONCATENATED MODULE: ./components/desktop/organisms/Combo/ComboCarouselNew.tsx
function ComboCarouselNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ComboCarouselNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ComboCarouselNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ComboCarouselNew_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ComboCarouselNew_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ComboCarouselNew_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ComboCarouselNew_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ComboCarouselNew_templateObject() {
    const data = ComboCarouselNew_taggedTemplateLiteral([
        "\n  .glide__arrow--override {\n    visibility: visible;\n  }\n"
    ]);
    ComboCarouselNew_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












const ComboCarouselNew = ()=>{
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const productComboHook = (0,useComboList/* useProductCombos */.rK)({
        skus: (product === null || product === void 0 ? void 0 : product.sku) ? [
            product.sku
        ] : undefined
    });
    const { activeCombo , setActiveCombo , comboGroup  } = productComboHook;
    const { numberDisplayFormat , epicOmni1643  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    // activeTab state includes index of currently active tab and total products of each combo in active group
    const { 0: activeTab , 1: setActiveTab  } = (0,react.useState)({
        index: 0
    });
    // Index of selected slider in Glide on each tab
    const { 0: displayedSlider , 1: setDisplayedSlider  } = (0,react.useState)();
    // State to keep product sku that user click to "Change product", state also keep both combo key & condition key containing product
    const { 0: selectingProduct , 1: setSelectingProduct  } = (0,react.useState)();
    const { 0: visible , 1: setVisible  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        // set initial activeTab value
        if (comboGroup && !activeTab.totalProductTab) {
            setActiveTab({
                index: 0,
                totalProductTab: Number(Object.keys(comboGroup)[0])
            });
        }
        // set initial displayedSlider value
        if (comboGroup && !displayedSlider) {
            const value = Object.keys(comboGroup).reduce((result, totalProduct)=>ComboCarouselNew_objectSpreadProps(ComboCarouselNew_objectSpread({}, result), {
                    [totalProduct]: 0
                }), {});
            setDisplayedSlider(value);
        }
    }, [
        JSON.stringify(comboGroup)
    ]);
    return comboGroup ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    padding: "s12",
                    justify: "start",
                    align: "middle",
                    backgroundColor: epicOmni1643 ? "secondary100" : "primary100",
                    style: {
                        borderRadius: "8px 8px 0 0"
                    },
                    height: epicOmni1643 ? 60 : 72,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            src: epicOmni1643 ? combo_header_label : icon_combo_desktop,
                            height: 40,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Title */.Dx, {
                            style: {
                                display: "inline",
                                marginLeft: "12px"
                            },
                            children: (0,i18n.t)("Mua k\xe8m nhận ưu đ\xe3i")
                        })
                    ]
                }),
                border: epicOmni1643 ? "1px solid #00000026" : "none",
                margin: epicOmni1643 ? [
                    "s12",
                    "s0"
                ] : "s0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_es/* Tabs */.m, {
                    activeTab: activeTab.index,
                    textColor: "textSecondary",
                    textActiveColor: "primary",
                    children: Object.entries(comboGroup).map((param, index)=>{
                        let [totalProduct, { combos  }] = param;
                        var ref;
                        const discount = combos.length === 1 ? combos[0].discountByCombo : (ref = combos[(displayedSlider === null || displayedSlider === void 0 ? void 0 : displayedSlider[totalProduct]) || 0]) === null || ref === void 0 ? void 0 : ref.discountByCombo;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem_es/* TabItem */.E, ComboCarouselNew_objectSpreadProps(ComboCarouselNew_objectSpread({
                            tabId: index,
                            onClick: ()=>{
                                setActiveTab({
                                    index,
                                    totalProductTab: Number(totalProduct)
                                });
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                align: "center",
                                direction: "column",
                                padding: [
                                    "s12",
                                    "s0"
                                ],
                                gap: "s4",
                                height: 64,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                        level: index === activeTab.index ? 2 : 1,
                                        color: index === activeTab.index ? "primary" : "textSecondary",
                                        children: (0,i18n.t)("Combo {{totalProduct}} sản phẩm", {
                                            totalProduct
                                        })
                                    }),
                                    !!discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_es/* Tag */.V, {
                                        content: (0,i18n.t)("Giảm đến {{discount}}", {
                                            discount: (0,number_es/* formatCurrency */.xG)(discount, numberDisplayFormat)
                                        }).toUpperCase(),
                                        type: "ghost",
                                        variant: index === activeTab.index ? "branding" : "default"
                                    })
                                ]
                            })
                        }, (0,helper_es/* getTrackingData */.O5)({
                            isTrackContent: true,
                            regionName: "productComboList",
                            contentName: "btnChangeComboTab",
                            payload: JSON.stringify({
                                comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                comboIndex: index + 1
                            })
                        })), {
                            children: combos.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboItemNew, {
                                index: 0,
                                combo: combos[0],
                                onClickProductChange: (selectedSku, conditionKey)=>{
                                    setVisible(true);
                                    setSelectingProduct({
                                        sku: selectedSku,
                                        conditionKey
                                    });
                                    setActiveCombo(combos[0]);
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GlideStyled, {
                                perView: 1,
                                startAt: (displayedSlider === null || displayedSlider === void 0 ? void 0 : displayedSlider[totalProduct]) || 0,
                                onSlideChange: (index)=>{
                                    if (typeof index === "number" && index >= 0) {
                                        setDisplayedSlider(ComboCarouselNew_objectSpreadProps(ComboCarouselNew_objectSpread({}, displayedSlider), {
                                            [totalProduct]: index
                                        }));
                                    }
                                },
                                trackingArrowRight: (0,helper_es/* getTrackingData */.O5)({
                                    isTrackContent: true,
                                    regionName: "productComboList",
                                    contentName: "btnChangeCombo",
                                    payload: JSON.stringify({
                                        comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                        comboPromotion: combos[(displayedSlider === null || displayedSlider === void 0 ? void 0 : displayedSlider[totalProduct]) || 0].promotion.id,
                                        comboIndex: ((displayedSlider === null || displayedSlider === void 0 ? void 0 : displayedSlider[totalProduct]) || 0) + 1,
                                        target: "next"
                                    })
                                }),
                                trackingArrowLeft: (0,helper_es/* getTrackingData */.O5)({
                                    isTrackContent: true,
                                    regionName: "productComboList",
                                    contentName: "btnChangeCombo",
                                    payload: JSON.stringify({
                                        comboTab: "Combo ".concat(totalProduct, " sản phẩm"),
                                        comboPromotion: combos[(displayedSlider === null || displayedSlider === void 0 ? void 0 : displayedSlider[totalProduct]) || 0].promotion.id,
                                        comboIndex: ((displayedSlider === null || displayedSlider === void 0 ? void 0 : displayedSlider[totalProduct]) || 0) + 1,
                                        target: "previous"
                                    })
                                }),
                                children: combos.map((cb, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ComboItemNew, {
                                        index: index,
                                        combo: cb,
                                        onClickProductChange: (selectedSku, conditionKey)=>{
                                            setVisible(true);
                                            setSelectingProduct({
                                                sku: selectedSku,
                                                conditionKey
                                            });
                                            setActiveCombo(cb);
                                        }
                                    }, index))
                            }, visible ? 1 : 0)
                        }), index);
                    })
                })
            }),
            visible && activeCombo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSelectionModal/* ProductSelectionModal */.y, ComboCarouselNew_objectSpread({
                closeModal: (selectingCombo)=>{
                    setVisible(false);
                    setSelectingProduct(undefined);
                    // set active tab according to active combo
                    if (selectingCombo) {
                        const indexTab = Object.keys(comboGroup).findIndex((item)=>Number(item) === selectingCombo.totalProduct);
                        setActiveTab({
                            index: indexTab,
                            totalProductTab: selectingCombo.totalProduct
                        });
                        if (comboGroup && activeTab.totalProductTab) {
                            const activeGroup = comboGroup[activeTab.totalProductTab];
                            const selectedIndex = activeGroup.combos.findIndex((el)=>el.key === selectingCombo.key);
                            setDisplayedSlider(ComboCarouselNew_objectSpreadProps(ComboCarouselNew_objectSpread({}, displayedSlider), {
                                [selectingCombo.totalProduct]: selectedIndex
                            }));
                        }
                    }
                },
                selectingProduct: selectingProduct,
                visible: visible
            }, productComboHook))
        ]
    }) : null;
};
const GlideStyled = (0,emotion_styled_browser_esm["default"])(Glide_es/* Glide */.A)(ComboCarouselNew_templateObject());

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/ProductCombo.tsx





const ProductCombo = ()=>{
    const { epicOmni1286  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { comboList  } = (0,useComboList/* useComboList */.KV)(product === null || product === void 0 ? void 0 : product.sku);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !epicOmni1286 && !!(comboList === null || comboList === void 0 ? void 0 : comboList.length) && (product === null || product === void 0 ? void 0 : product.sku) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboCarousel, {
                comboList: comboList,
                mainSku: product === null || product === void 0 ? void 0 : product.sku
            }),
            epicOmni1286 && (product === null || product === void 0 ? void 0 : product.sku) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboCarouselNew, {})
        ]
    });
};


/***/ })

}]);